<template>
  <BDropdown
    class="user-status"
    variant="outline-dark"
    right
    :text="$store.state.auth.username"
  >
    <BDropdownItem @click="$store.dispatch('auth/logout')">ausloggen</BDropdownItem>
  </BDropdown>
</template>

<script>
export default {
  name: 'UserStatus',
};
</script>

<style scoped>

</style>
